export const noteTraditional = (data, hideInitialNote) => {
  const dataTraditional = data;
  const getSingapore = dataTraditional?.find((item) => item.id === 191);
  const findSpecialBank = getSingapore?.banks.find(
    (item) => item.name === "OCBC Bank*"
  );
  let note =
    "**Initial deposit is often blocked in the offshore bank account; if so, this amount is often small.<br/> However, banks in Hong Kong and Singapore do not freeze this amount, so you can use it freely. But you will be charged an additional fee for not maintaining your account above min balance.";

  if (getSingapore && findSpecialBank) {
    if (hideInitialNote) {
      note =
        "* Remote opening applies for Singapore-incorporated companies only.";
    } else {
      note +=
        "<br/>* Remote opening applies for Singapore-incorporated companies only.";
    }
  } else {
    if (hideInitialNote) {
      note = null;
    }
  }

  return note;
};
